/**
 * 安全获取对象属性，类似 lodash.get
 * @param {object} obj - 目标对象
 * @param {string} path - 属性路径
 * @param {any} defaultValue - 默认值
 * @returns {any}
 */
export const get = (obj, path, defaultValue = undefined) => {
    const travel = (regexp) =>
        String.prototype.split
            .call(path, regexp)
            .filter(Boolean)
            .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
    const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
    return result === undefined || result === obj ? defaultValue : result;
};

export default get;

/**
 * 读取cookie
 */
export function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return decodeURIComponent(match[2]);
    return null;
}